import { Container, Tab, Tabs } from '@mui/material';
import React from 'react';
import { Redirect, Route, Switch, useHistory, useLocation } from 'react-router-dom';
import { Props } from '../container';
import { EditContainer } from '../edit/container';
import { PortfoliosContainer } from '../portfolios/container';
import { ReportsContainer } from '../reports/container';
import { ReportSettingsContainer } from '../report-settings/container';

export const Templates = ({ hasDashEmail }: Props): JSX.Element => {
  const { pathname } = useLocation();
  const history = useHistory();

  const getValue = (): string => {
    if (pathname.startsWith('/templates/portfolios')) return '0';
    if (pathname.startsWith('/templates/email')) return '1';
    if (pathname.startsWith('/templates/report-settings')) return '2';
    if (pathname.startsWith('/templates/reports')) return '3';
    return '0';
  };

  return (
    <Container style={{ padding: '20px' }}>
      <Tabs value={getValue().toString()} TabIndicatorProps={{ style: { height: '4px' } }} style={{ padding: '0 24px 10px' }}>
        <Tab onClick={() => history.replace(`/templates/portfolios`)} value="0" label="PORTFOLIO" />
        <Tab value="1" label="EMAIL" disabled={true} />
        <Tab onClick={() => history.replace(`/templates/report-settings`)} value="2" label="REPORT SETTINGS" />
        {hasDashEmail && <Tab onClick={() => history.replace(`/templates/reports`)} value="3" label="REPORTS" />}
      </Tabs>
      <Switch>
        <Route exact path={`/templates`} render={() => <Redirect to={`templates/portfolios`} />} />
        <Route exact path={`/templates/portfolios/:afslId?`} component={PortfoliosContainer} />
        <Route path={`/templates/portfolios/:afslId/:id`} component={EditContainer} />
        <Route path={`/templates/report-settings/:afslId?`} component={ReportSettingsContainer} />
        {hasDashEmail && <Route path="/templates/reports" component={ReportsContainer} />}
      </Switch>
    </Container>
  );
};
